import styled from '@emotion/styled';

const Wrapper = styled.div`
  max-width: 720px;
  margin: 0 auto 1.5rem;
`;

const Intro = styled.p`
  text-align: center;
  font-size: 1.05rem;
  color: #495057;
  margin: 1.5rem auto 1.25rem;
  max-width: 640px;
  line-height: 1.6;
`;

const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 4px solid #e74c3c;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  @media screen and (max-width: 750px) {
    padding: 1rem;
  }
`;

const Question = styled.p`
  font-weight: 600;
  font-size: 1rem;
  color: #2c3e50;
  margin: 0 0 1rem;
  line-height: 1.5;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #f1f3f5;
`;

const Comparison = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.75rem;
  align-items: stretch;

  @media screen and (max-width: 750px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`;

const Answer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  min-height: 100%;
`;

const UserAnswer = styled(Answer)`
  background: linear-gradient(180deg, #fff8f8 0%, #fff5f5 100%);
  border: 1px solid #f5c6cb;
`;

const ExpectedAnswer = styled(Answer)`
  background: linear-gradient(180deg, #f4fdf7 0%, #ecfdf3 100%);
  border: 1px solid #a7f3d0;
`;

const Label = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ variant }) => (variant === 'user' ? '#b91c1c' : '#047857')};
`;

const Value = styled.span`
  font-size: 0.95rem;
  line-height: 1.5;
  word-break: break-word;
  font-weight: 600;
  color: ${({ variant }) => (variant === 'user' ? '#991b1b' : '#065f46')};
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #868e96;
  font-size: 1rem;
  flex-shrink: 0;

  @media screen and (max-width: 750px) {
    transform: rotate(90deg);
    margin: 0.25rem auto;
  }
`;

const Outro = styled.p`
  text-align: center;
  color: #6c757d;
  font-size: 0.95rem;
  margin: 0 auto;
  max-width: 640px;
  line-height: 1.6;
`;

const MissingConditionsSummary = ({ intro, outro, items = [] }) => (
  <Wrapper>
    {intro && <Intro>{intro}</Intro>}
    <Summary>
      {items.map((item, index) => (
        <Card key={`${item.question}-${index}`}>
          <Question>{item.question}</Question>
          <Comparison>
            <UserAnswer>
              <Label variant="user">Tu respuesta</Label>
              <Value variant="user">{item.userAnswer}</Value>
            </UserAnswer>
            <Divider aria-hidden="true">→</Divider>
            <ExpectedAnswer>
              <Label variant="expected">Se requiere</Label>
              <Value variant="expected">{item.expectedAnswer}</Value>
            </ExpectedAnswer>
          </Comparison>
        </Card>
      ))}
    </Summary>
    {outro && <Outro>{outro}</Outro>}
  </Wrapper>
);

export default MissingConditionsSummary;
